import { render, staticRenderFns } from "./closeable-message.vue?vue&type=template&id=6ba24514&"
import script from "./closeable-message.vue?vue&type=script&lang=js&"
export * from "./closeable-message.vue?vue&type=script&lang=js&"
import style0 from "./closeable-message.vue?vue&type=style&index=0&id=6ba24514&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports